import { createVNode as _createVNode } from "vue";
import "core-js/modules/es.array.push.js";
import { defineComponent, reactive, watch, onMounted } from "vue";
import { useRouter } from "vue-router";
import _ from "lodash";
// config
import { navList } from "@/config/common";
// components
export default defineComponent({
  name: "MNavBar",
  setup() {
    const router = useRouter();
    // 组件状态
    const state = reactive({
      activeIndex: null
    });

    // 获取当前选中
    function getAct(url) {
      navList.find(item => {
        const list = item.url;
        if (list.includes(url)) {
          state.activeIndex = item.status;
          document.getElementById("container-id").scrollTop = 0;
        }
      });
    }
    onMounted(() => {
      const nowUrl = location.hash.length > 2 ? location.hash.slice(1, location.hash.indexOf("?")) : "/";
      getAct(nowUrl);
    });

    // 监听路由变化
    watch(() => router.currentRoute.value.path, val => {
      getAct(val);
    });
    const handleClick = (status, url) => {
      state.activeIndex = status;
      router.push(url);
    };
    return () => {
      const builtNavItem = _.map(navList, item => {
        return _createVNode("div", {
          "class": "nav-img",
          "onClick": () => handleClick(item.status, item.url[0])
        }, [_createVNode("img", {
          "class": state.activeIndex === item.status ? "img act" : `img ${item.img}`,
          "src": require(`@/assets/img/m/homePage/${item.img}${state.activeIndex === item.status ? "-act" : ""}.png`)
        }, null)]);
      });
      return _createVNode("div", {
        "class": "nav-bar"
      }, [builtNavItem]);
    };
  }
});